module.exports = __webpack_public_path__ + "svg/social-apple.svg?83a8d7200ade50da2bb5e3b2fd8ba28f";